import { fetchUserInfo, type UserInfo } from '@/api/user'
import { getCurrentLanguage } from '@hgj/common-tools'
import { getProductCodeByUrl } from '@/utils/common'

/**
 * @description:用户信息
 * @return {*}
 */
const useUserStore = defineStore('user', () => {
  const { domain } = getProductCodeByUrl()
  const enterPriseKey = useStorage(
    `${domain.toUpperCase()}_ENTERPRISE_KEY__`,
    {},
    window.sessionStorage,
  )

  const info = ref<Partial<UserInfo>>({})
  const caatParties = ref<Dict[]>([])
  /** 默认的caatCode */
  const defaultCaatCode = ref<string>('')
  /** 海管家caatCode */
  const hgjCaatCode = ref<string>('')
  const isLogin = computed(() => !!info.value?.user?.userId)
  const user = computed(() => info.value?.user)
  const isSuperAdmin = computed(() => info.value?.user?.superAdmin)
  const globalSeaCoins = computed(() => info.value?.globalSeaCoins || [])
  const enabledCurrencies = computed(() => info.value?.enabledCurrencies || [])
  const globalSeaCoinCurrencyByLang = computed(() => {
    const lang = getCurrentLanguage()
    const langMap: { [key: string]: any } = {
      'zh-CN': 'CNY',
      vi: 'VND',
      en: 'USD',
    }
    return langMap[lang]
  })
  // 保存的用户的access-token
  const sessionId: Ref<string | null> = ref(null)

  function setSessionId(id: string) {
    sessionId.value = id
  }

  const getSessionId = computed(() => sessionId.value)

  const getUserInfo = async (): Promise<UserInfo> => {
    const res = await fetchUserInfo()
    setSessionId(res?.user?.accessToken || '')
    info.value = res
    const list =
      res.extData?.caatParties?.map((item: any) => {
        return {
          ...item,
          label: item.caatCode,
          value: item.caatCode,
        }
      }) || []
    if (res.changeHouseScac) {
      caatParties.value = list
    } else {
      caatParties.value = [list[0]]
    }
    defaultCaatCode.value = res.extData?.caatParties?.[0]?.caatCode || ''
    hgjCaatCode.value =
      res.extData?.caatParties?.find((item: any) => item.hgj)?.caatCode || ''
    return res
  }

  /**
   * 用户产品是否可用
   */
  const isProjectEnabled = computed(() => info.value?.openStatus == 'ACCEPTED')

  /**
   * 企业是否可用
   */
  const isCompanyEnabled = computed(() => info.value?.user?.enabled)

  return {
    info,
    /** 是否登录 */
    isLogin,
    enterPriseKey,
    caatParties,
    defaultCaatCode,
    hgjCaatCode,
    user,
    /** 是否是超级管理员 */
    isSuperAdmin,
    getUserInfo,
    setSessionId,
    getSessionId,
    /** 用户产品是否可用 */
    isProjectEnabled,
    /** 企业是否可用 */
    isCompanyEnabled,
    globalSeaCoins,
    globalSeaCoinCurrencyByLang,
    enabledCurrencies,
  }
})

export default useUserStore
